import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';
import JisUser from '../../components/controls/jisUser';
import Pagenated from '../../components/pagenated';

function JudgeSettings() {
  const {activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
    const [page, setPage] = useState(null);
    const [tab, setTab] =useState('judges');
    const [judge, setJudge] = useState({id:0,roleId:null, isOrg:false, isJudge:true});

  const [roles, setRoles]= useState([]);
    const [judgeType, setJudgeType] = useState({id:0});
    const [judges, setJudges] = useState([]);
    const [judgeTypes, setJudgeTypes] = useState([]);
    const [search, setSearch] = useState({})
      const [pageIndex, setPageIndex]=useState(0);
      const [pageSize,setPageSize] = useState(30);
      const [totalcount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isDialog,setIsDialog] =useState(false);
    const [aIndex, setAIndex] = useState(-1);
    const [isSearch, setIsSearch] =useState(false);
    const [err, setErr] =useState('');
    const [isPreview, setIsPreview]= useState(false);

    const [judgeCaseCats, setJudgeCaseCats]= useState([]);
    const [judgeCaseCat, setJudgeCaseCat] =useState({id:0});
    const [caseCats, setCaseCats] = useState([]);
   
    useEffect(() => {
        onLoadJudgeTypes();
               onLoadRole();
           onLoadJudges();
           onLoadCaseCategory();
    }, []);

 const onLoadRole= async()=>{
     //for account registration
     try {
       setLoading(true);
         const resp = await fetch(`${Constants.apiUrl}/profile/roles`, { 
           method: 'GET',
           headers: {
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${token}`,
           },
         });
         
         const data = await resp.json();
          setLoading(false);
        setRoles(data);
        
       } catch (error) {
         setLoading(false);
         console.error(error);
         
       }
 }
  const onLoadCaseCategory=async()=>{
           try {
                setLoading(true);
                  const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-categories`, { 
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`,
                    },
                  });
                  
                  const data = await resp.json();
                  setLoading(false);
                  if(data.code==0){
                     setCaseCats(data.list);
                  }else if(data.code==-10){
                     setIsExpired(true)
                  }
                
                 
                } catch (error) {
                  setLoading(false);
                  console.error(error);
                  
                }
     }

    const onJudgeChange = (e) => {
        setJudge({...judge, [e.target.name]: e.target.value})   
    }

    const onJudgeTypeChange = (e) => {
        setJudgeType({...judgeType, [e.target.name]: e.target.value})   
    }

    const onJudgeCaseCat = (e) => {
        setJudgeCaseCat({...judgeCaseCat, [e.target.name]: e.target.value})   
    }

 const onAdd=()=>{
        setIsDialog(true);
    }
    const onClose=()=>{
        setIsDialog(false);
        setJudge({id:0,roleId:null, isOrg:false, isJudge:true})
        setJudgeType({id:0});
    }

    const onSaveJudge=(e)=>{
        //saved user
        console.log(e);
        onClose();
        setAlert({open:true, title:'Judge', subtitle:'Judge saved successfully'});
        onLoadJudges();
    }


 const onLoadJudges= async()=>{
      //for account registration
      try {
        setLoading(true);
          const resp = await fetch(`${Constants.apiUrl}/profile/profileusers/judge/${pageIndex}/${pageSize}`, { 
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          setLoading(false)
          if(data.code==0){
           setJudges(data.items)
           if(data.totalCount>0){
                     setTotalCount(data.totalCount)
                   }
                   
          }else if(data.code==-10){
                       setIsExpired(true);
                   }
         
         
        } catch (error) {
          setLoading(false);
          console.error(error);
          
        }
  }
  
 const onSearchChange = (e) => {
    setSearch({...search, [e.target.name]: e.target.value})
} 
const onSearch=async(sear)=>{ 
              setIsSearch(true);
              console.log(sear);

             setSearch(sear)       ;
             setLoading(true)
             try {
             
             const resp = await fetch(`${Constants.apiUrl}/profile/profileusers/judge/${pageIndex}/${pageSize}`, {
                 method: 'POST',
                 body:JSON.stringify(sear) ,
                 headers: {
                 'Content-Type': 'application/json, text/plain',
                 Authorization: `Bearer ${token}`,
                 },
             });
             
             const data = await resp.json();
             setLoading(false);
              if(data.code==0){
                  setJudges(data.items)
                  if(data.totalCount>0){
                    setTotalCount(data.totalCount)
                  }
                  
              }else if(data.code==-10){
                      setIsExpired(true);
                  }
              else{
             //there is an error
             setErr(data.status);
             }
             
             } catch (error) {
             setLoading(false);
             console.error(error);
             setErr(Constants.serverErr);
             // onMove();
             }
         }  
  const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}
const onView =(it,ind) =>{
  setIsPreview(true);
  setJudge(it);
  setAIndex(ind);
  setIsDialog(true);
}

const onSaveType=async(e)=>{
     e.preventDefault();
     setErr('')
              setLoading(true)
              try {
               
                const url=`${Constants.apiUrl}/setup/judge-setting/judge-type`;
                const resp = await fetch(url, {
                  method: 'POST',
                  body:JSON.stringify(judgeType) ,
                  headers: {
                    'Content-Type': 'application/json, text/plain',
                    Authorization: `Bearer ${token}`,
                  },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                    onClose();
                    onLoadJudgeTypes();
                     setAlert({open:true, title:'Judge Type', subtitle:'Judge saved successfully'})
                }
                else if(data.code==-10){
                      setIsExpired(true);
                  }else{
                    setErr(data.status);
                  }
             //   setFlow({pos:6,code:"congrat"})
                
                
              } catch (error) {
                setLoading(false);
                console.error(error);
                
               // onMove();
              }
}
 const onLoadJudgeTypes= async()=>{
     //for account registration
     try {
       setLoading(true);
         const resp = await fetch(`${Constants.apiUrl}/setup/judge-setting/judge-types`, { 
           method: 'GET',
           headers: {
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${token}`,
           },
         });
         
         const data = await resp.json();
        setJudgeTypes(data.list);
        
       } catch (error) {
         setLoading(false);
         console.error(error);
         
       }
 }

 const onSaveJudgeCaseCategory=async(e)=>{
     e.preventDefault();
     setErr('')
              setLoading(true)
              try {
               
                const url=`${Constants.apiUrl}/setup/judge-setting/judge-case-category`;
                const resp = await fetch(url, {
                  method: 'POST',
                  body:JSON.stringify(judgeType) ,
                  headers: {
                    'Content-Type': 'application/json, text/plain',
                    Authorization: `Bearer ${token}`,
                  },
                });
                
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                    onClose();
                    onLoadJudgeCaseCategory();
                     setAlert({open:true, title:'Judge Case Category', subtitle:' Judge Case Category saved successfully'})
                }
                else if(data.code==-10){
                      setIsExpired(true);
                  }else{
                    setErr(data.status);
                  }
             //   setFlow({pos:6,code:"congrat"})
                
                
              } catch (error) {
                setLoading(false);
                console.error(error);
                
               // onMove();
              }
}
 const onLoadJudgeCaseCategory= async()=>{
     //for account registration
     try {
       setLoading(true);
         const resp = await fetch(`${Constants.apiUrl}/setup/judge-setting/judge-case-categories`, { 
           method: 'GET',
           headers: {
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${token}`,
           },
         });
         
         const data = await resp.json();
         if(data.code==0){
           setJudgeCaseCats(data.list);
         }else if(data.code==-10){
          setIsExpired(true);
         }
       
        
       } catch (error) {
         setLoading(false);
         console.error(error);
         
       }
 }

 const onEdit=(obj,index)=>{
    setJudgeType(obj);
    setAIndex(index);
    setIsDialog(true)
 }

  return (
    <div>
     <div  className='tab_body'>
        <div className='tab_section' style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <JisTabButton code="judges" isActive={tab=='judges'}  title="Judges" data={page}  isRoleBased={false} onClick={()=> setTab('judges')}/>
          <JisTabButton code="judgetypes" isActive={tab=='judgetypes'}  title="Judge Types" data={page} isRoleBased={false}  onClick={()=> setTab('judgetypes')}/>
        </div>
      {tab=="judges" && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Judge</JisButton></div>
             <div className='panel'>
          <div className="title"> User search</div>
          <div  className="panel-body">
<div style={{display:'flex'}}>
          <div  className="input-group">
                        <label> First Name</label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="person_3" />
                            <input placeholder='First Name' name="firstname" value={search.firstname} onChange={onSearchChange}   />
                        </div>
                    </div>
           <div  className="input-group">
                        <label> Last Name</label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="person_3" />
                            <input placeholder='Last Name'  name="lastname" value={search.lastname} onChange={onSearchChange}   />
                        </div>
                    </div>  
           <div  className="input-group">
                        <label> User Name</label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="person_3" />
                            <input placeholder='User Name' name="username" value={search.username} onChange={onSearchChange}   />
                        </div>
                    </div>                
        </div>
        <div style={{display:'flex'}}>
          <div className="select-group">
                          <label>
                              Role  
                          </label>
                          <select name="roleid" value={search.roleid}  onChange={onSearchChange} >
                              <option value="">All </option>
                              {roles.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.name}
                              </option>
                              ))}
                          </select>
                      </div>
        <div className="select-group">
                          <label>
                              Case Category  
                          </label>
                          <select name="roleid" value={search.roleid}  onChange={onSearchChange} >
                              <option value="">All </option>
                              {caseCats.filter((d)=>d.isActive).map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.categoryTitle}
                              </option>
                              ))}
                          </select>
                      </div>              
<div className="select-group">
                          <label>
                              Division  
                          </label>
                          <select name="divisionid" value={search.divisionid}  onChange={onSearchChange} >
                              <option value="">All </option>
                              {frequentData.divisions?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.title}
                              </option>
                              ))}
                          </select>
                      </div>
        </div>
          </div>
            
          <div className='panel-btn'><JisButton onClick={()=>onSearch(search)} >Search</JisButton></div>        

      </div>

    <div className="table">
                <div class="section-cases">
                <span>Users</span>
                </div>
                <table class="case-table">
                    <thead>
                        <tr>
                            {/* <th className="col-id">ID</th> */}
                            
                            <th className="col-id">SN</th>
                            <th className="col-title"> Name</th>
                            <th className="col-title">User Name</th>
                            <th className="col-medium">Role</th>
                            <th className="col-medium">Division</th>
                            <th className="col-medium">Case Category</th>
                            <th className="col-medium">Created On</th>
                            <th className="col-action">View</th>
                        </tr>
                    </thead>
                    <tbody>
                        { judges.map((item, index) => { return (
                            <tr key={index} className={`${aIndex==index?'active':''}`}>
                           
                                <td>{index+ (pageSize*pageIndex) +1}</td>
                                <td>{item.firstName} {item.lastName??''}</td>
                                <td >{item.userName}</td>
                                <td>{Constants.getItemById(roles,item.roleId)?.name}</td>
                                <td> {Constants.getItemById(frequentData.divisions,item.divisionId)?.title} </td>
                                <td>
                                  {item.categoryIds?.length==0?"None":<div>
                                    {item.categoryIds.map((opt) => (
                                        <div key={opt} className='selected'>
                                            {Constants.getItemById(caseCats,opt)?.categoryTitle}
                                        </div>
                                        ))}
                                    </div>}
                                   </td>
                                <td> {Constants.momentDate(item.createdOn)?.format('DD MMM, YYYY')}</td>
                                <td> 
                                    <JisButton  onClick={()=>onView(item,index)}> View Profile </JisButton> 
                                </td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            {judges?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={totalcount} maxPage={20}  onPick={onPagePick}/>}    
            </div>
        </div>}  

      {tab=="judgetypes" && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Judge Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Judge Types</span><span className='total'>{judgeTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th className="col-id">SN</th>
                        <th className="col-title">Title</th>
                        <th>Status</th>
                        <th className="col-action">Action</th>
                    </tr>
                </thead>
                <tbody>
                   { judgeTypes.map((g, i) => { return (
                    <tr>
                        <th>{i+1}</th>
                        <td>{g.title}</td>
                         <td>{g.isActive?'Active':'Inactive'}</td>
                         <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  

     </div>
<BackLoader open={loading} />
    {isDialog && tab=='judges' && <JisDialogForm title="Judge" onClose={onClose}>
        <JisUser defaultUser={judge} onSave={onSaveJudge} source="judge"/>
     </JisDialogForm>} 
    
    {isDialog && tab=="judgetypes" && <JisDialogForm title="Judge Type" onClose={onClose}>
            <form onSubmit={onSaveType}>
                <div  className="input-group">
                    <label> Title</label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                        <input placeholder='Title' name="title" value={judgeType.title} onChange={onJudgeTypeChange}   />
                    </div>
                </div>

            <JisCheckbox value={judgeType.isActive} label="Active" onChange={(e)=>setJudgeType({...judgeType,isActive:e})} />
            <div><JisButton type='submit'>{judgeType.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>}

     {isDialog && tab=="judgecasecat" && <JisDialogForm title="Judge Case Category" onClose={onClose}>
            <form onSubmit={onSaveJudgeCaseCategory}>
                <div  className="input-group">
                    <label> </label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="person_3" />
                        <input placeholder='Title' name="title" value={judgeType.title} onChange={onJudgeCaseCat}   />
                    </div>
                </div>

            <JisCheckbox value={judgeCaseCat.isActive} label="Active" onChange={(e)=>setJudgeType({...judgeType,isActive:e})} />
            <div><JisButton type='submit'>{judgeCaseCat.id==0?'Save':'Update'} </JisButton></div> 

            </form>
        </JisDialogForm>}    

    </div>
  );
}

export default JudgeSettings;